export enum EPage {
  Main = 'main',
  Payment = 'payment',
}
